import spartaStyleUtility from "utilities/global/sparta-style-utility/4.5.0/js/sparta-style-utility";
class spartaSpinnerUtility {
  constructor() {
    this._delayTime = 10000;
    this._eventHandlersAttached = false;
  }

  getTargetElements() {
    this._cancelDisabled = this._target.querySelector('.spa-spin-cancel-btn').style.display === 'none' ? true : false;
    this._cancelBtn = this._target.querySelector('.spa-spin-cancel-btn');
    this._retryBtn = this._target.querySelector('.spa-spin-retry-btn');
    this._retryDisabled = this._retryBtn.classList.contains('spin-retry-disabled');
    this._loadMsg = this._target.querySelector('.spa-spin-load-msg');
    this._cancelMsg = this._target.querySelector('.spa-spin-cancel-msg');
    this._errorMsg = this._target.querySelector('.spa-spin-error-msg');
    this._loadText = this._target.querySelector('.spa-spin-msg-wrapper');
  }




  delayTime(delayTime) {
    if (delayTime) {
      this._delayTime = delayTime;
    }
    return this;
  }




  onCancel(onCancel) {
    if (onCancel) {
      this._onCancel = onCancel;
    }
    return this;
  }




  onRetry(onRetry) {
    if (onRetry) { this._onRetry = onRetry; }
    return this;
  }




  show(target) {
    this._target = target instanceof Element ? target : document.querySelector(target);
    this.getTargetElements();
    this._loadText.style.visibility = 'hidden';
    this._loadText.style.display = 'none';
    clearTimeout(this._messageTimeoutId);
    this.attachEventHandlers();
    this._target.querySelector('.spa-card').style.display = 'block';
    this.startMsgTimer();
    return this;
  }

  attachEventHandlers() {
    if (!this._eventHandlersAttached) {
      this._cancelBtn.addEventListener('click', this.cancel.bind(this), false);
      this._retryBtn.addEventListener('click', this.retry.bind(this), false);
      this._eventHandlersAttached = true;
    }
  }

  startMsgTimer() {
    this._messageTimeoutId = setTimeout(() => {
      this._loadText.style.visibility = 'visible';
      this._loadText.style.display = 'block';
    }, this._delayTime);
  }

  retry() {

    this._cancelMsg.setAttribute('aria-hidden', 'true');
    this._errorMsg.setAttribute('aria-hidden', 'true');
    this._loadMsg.setAttribute('aria-hidden', 'false');

    if (!this._cancelDisabled) {
      this._cancelBtn.style.display = 'block';
    }
    this._retryBtn.style.display = 'none';
    this._cancelMsg.style.display = 'none';
    this._errorMsg.style.display = 'none';
    this._loadText.style.visibility = 'hidden';
    this._loadMsg.style.display = 'block';
    this.startMsgTimer();
    if (this._onRetry && !this._retryDisabled) {
      this.executeCallback(this._onRetry, 'onRetry');
    }
  }

  showError() {
    this._loadMsg.setAttribute('aria-hidden', 'true');
    this._cancelMsg.setAttribute('aria-hidden', 'true');
    this._errorMsg.setAttribute('aria-hidden', 'false');
    this._cancelBtn.style.display = 'none';
    if (!this._retryDisabled) {
      this._retryBtn.style.display = 'block';
    }
    this._loadMsg.style.display = 'none';
    this._cancelMsg.style.display = 'none';
    this._errorMsg.style.display = 'block';
  }

  cancel() {
    this._errorMsg.setAttribute('aria-hidden', 'true');
    this._loadMsg.setAttribute('aria-hidden', 'true');
    this._cancelMsg.setAttribute('aria-hidden', 'false');
    this._cancelBtn.style.display = 'none';
    if (!this._retryDisabled) {
      this._retryBtn.style.display = 'block';
    }
    this._loadMsg.style.display = 'none';
    if (!this._cancelDisabled) {
      this._cancelMsg.style.display = 'block';
    }
    if (this._onCancel) {
      this.executeCallback(this._onCancel, 'onCancel');
    }
  }

  hide() {
    this._target.querySelector('.spa-card').style.display = 'none';
  }

  executeCallback(cb, name) {
    if (!cb) {
      return;
    }
    try {
      cb();
    } catch (err) {
      console.log(`Error executing callback ${name}: ${err}`);
    }
  }
}

export default spartaSpinnerUtility;